export { baseButtonPropDefs as iconButtonPropDefs } from './base-button.props.js';
